
const CLOUDFRONT_ENDPOINT = 'https://d1wqfechwjsewm.cloudfront.net/';
const S3_PRESIGN_URL = 'https://v2ao5dt0v3.execute-api.ap-south-1.amazonaws.com/prod/v1/data/presign/url';
// dev
// const EMAIL_SERVER_URL = 'http://localhost:7878/api';
// const SERVERLESS_URL = 'http://localhost:7878/api';
// const SMS_SERVER_URL = 'http://localhost:7878/api';
// const OPEN_API_ENDPOINT = 'http://localhost:7878/api';
//const TINY_BASE_URL = 'http://localhost:7878'


const stage = 'server-ip';

// 

// // prod

// sas-prod
var EMAIL_SERVER_URL = 'https://secureapi.sendshortly.com/api';
var SMS_SERVER_URL = 'https://secureapi.sendshortly.com/api';
var SERVERLESS_URL = 'https://secureapi.sendshortly.com/api'
var OPEN_API_ENDPOINT = 'https://secureapi.sendshortly.com/api';

var PRESIGN_URL_ENDPOINT = `https://v2ao5dt0v3.execute-api.ap-south-1.amazonaws.com/prod/v1/data`;


if (stage === 'server-ip') {
    EMAIL_SERVER_URL = '/api';
    SMS_SERVER_URL = '/api';
    SERVERLESS_URL = '/api'
    OPEN_API_ENDPOINT = '/api';


    // PRESIGN_URL_ENDPOINT = `http://localhost:3000/v1/data`;

    PRESIGN_URL_ENDPOINT = `https://v2ao5dt0v3.execute-api.ap-south-1.amazonaws.com/prod/v1/data`;



}


if (stage === 'local-ip') {
    EMAIL_SERVER_URL = 'http://localhost:7878/api';
    SMS_SERVER_URL = 'http://localhost:7878/api';
    SERVERLESS_URL = 'http://localhost:7878/api'
    OPEN_API_ENDPOINT = 'http://localhost:7878/api';


    PRESIGN_URL_ENDPOINT = `http://localhost:7878/v1/data`;



}





const TINY_BASE_URL = 'sstiny.in'
const ORG_CODE = 'aau'

//const TINY_BASE_URL = 'sms.sstiny.com'

module.exports = {
    EMAIL_SERVER_URL,
    SERVERLESS_URL,
    OPEN_API_ENDPOINT,
    SMS_SERVER_URL,
    TINY_BASE_URL,
    ORG_CODE,
    CLOUDFRONT_ENDPOINT,
    S3_PRESIGN_URL,
    PRESIGN_URL_ENDPOINT
}